import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/quiz-management")({
  component: QuizManagementLayout,
})

function QuizManagementLayout() {
  return <Outlet />
}
